export default __webpack_public_path__ + "static/media/NFT_Alley_Final.57d9f7b7.png";